/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetAllJobsParams = {
  job_id?: string | null;
  completed?: boolean;
  all_users?: boolean;
};
